module.exports = __webpack_public_path__ + "be472a3c3ec19e433135df70fca66dc7.png";